
import { ChefHat, CalendarDays, ShoppingCart, Compass, Heart, Navigation, UserRound, Gift, Download, Bell, Users, BookOpen } from 'lucide-react';

// Define an interface for navigation items
interface NavigationItem {
  title: string;
  href: string;
  icon: any; // Using 'any' for the Lucide icon component types
  highlight?: boolean;
  bgColor?: string;
  isExternal?: boolean;
}

export const navigationItems: NavigationItem[] = [
  {
    title: 'Explora',
    href: '/explora',
    icon: Compass,
  },
  {
    title: 'Recetas',
    href: '/recetas',
    icon: ChefHat,
  },
  {
    title: 'Menú Semanal',
    href: '/menu-semanal',
    icon: CalendarDays,
  },
  {
    title: 'Lista de Compra',
    href: '/lista-compra',
    icon: ShoppingCart,
  },
  {
    title: 'Diario de Hábitos',
    href: '/diario-nutricional',
    icon: Heart,
  },
  {
    title: 'Comunidad',
    href: 'https://t.me/+019yrxUsSjxhZjE0',
    icon: Users,
    bgColor: '#0088cc', // Color azul de Telegram
    isExternal: true,
  },
  {
    title: 'Tutoriales',
    href: '/tutoriales',
    icon: BookOpen,
  },
  {
    title: 'Comparte y Gana',
    href: '/programa-referidos',
    icon: Gift,
    highlight: true,
  },
];

export const adminNavigationItems: NavigationItem[] = [
  {
    title: 'Dashboard',
    href: '/admin/dashboard',
    icon: Navigation,
  },
  {
    title: 'Gestionar Recetas',
    href: '/admin/recipes',
    icon: ChefHat,
  },
  {
    title: 'Gestionar Usuarios',
    href: '/admin/users',
    icon: UserRound,
  },
  {
    title: 'Gestionar Tutoriales',
    href: '/admin/tutorials',
    icon: BookOpen,
  },
  {
    title: 'Notificaciones',
    href: '/admin/notifications',
    icon: Bell,
  }
];

export const getNavigationItems = (isAdmin = false) => {
  return isAdmin ? adminNavigationItems : navigationItems;
};
